export const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
};

export const formatDateWithHourAndMinute = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
};
  
export const formatDescription = (text) => {
    if (!text || text.length <= 110) return text;
    
    const linkLength = 15;
    const truncateAt = 90 - linkLength;
    
    return <>{text.slice(0, truncateAt)}... <span style={{ color: '#18964E', fontWeight: 600, cursor: 'pointer' }}>Devamını Gör &gt;</span></>;
};
  
// Helper function to get latest received record with description
export const getLatestReceivedRecordWithDescription = (records) => {
    return records
      .filter(r => r.dateReceived && r.description) // Only get received records with description
      .sort((a, b) => new Date(b.dateReceived) - new Date(a.dateReceived))[0]; // Sort by dateReceived and get the first one
};

export const getTodayAndTomorrow = () => {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    return {
      today: today.toISOString().split('T')[0],
      tomorrow: tomorrow.toISOString().split('T')[0]
    };
};

export const formatDateOption = (dateString, label) => {
    const date = new Date(dateString);
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    return `${date.toLocaleDateString('tr-TR', options)} (${label})`;
};

export const getDayName = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', { weekday: 'long' });
};

export const isToday = (dateString) => {
    const today = new Date();
    const date = new Date(dateString);
    return date.toDateString() === today.toDateString();
};

export const formatPlate = (plateString) => {
    if (!plateString) return '-';
    
    // Remove any existing spaces and convert to uppercase
    const cleaned = plateString.replace(/\s+/g, '').toUpperCase();
    
    // Match the pattern: 2 digits + letters + ending numbers, ignore anything after
    const match = cleaned.match(/(\d{2})([A-Z]+)(\d+)[A-Z]*$/);
    
    if (!match) return plateString; // Return original if pattern doesn't match
    
    // Destructure the matched groups (ignoring anything after the numbers)
    const [_, cityCode, letters, numbers] = match;
    
    // Format with spaces between components
    return `${cityCode} ${letters} ${numbers}`;
};

export const formatNumber = (number) => {
    if (typeof number !== 'number') {
        number = parseFloat(number);
    }
    return number.toLocaleString('tr-TR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
};

export const maskSensitiveData = (data) => {
    if (!data) return '';
    const str = String(data);
    if (str.length <= 3) return str;
    return str.substring(0, 2) + '*'.repeat(str.length - 2) + ' ' + str.substring(str.length - 1);
};